var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-table-of-contents",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeText,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.childElementsWithTasks.length > 0
                    ? _c("div", [
                        _vm.currentStyle !== "tiles" && _vm.currentTitle !== ""
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-block-title",
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.currentTitle) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentStyle === "list-details" ||
                        _vm.currentStyle === "list"
                          ? _c(
                              "ul",
                              {
                                class: [
                                  "cw-block-table-of-contents-" +
                                    _vm.currentStyle,
                                ],
                              },
                              _vm._l(
                                _vm.childElementsWithTasks,
                                function (child) {
                                  var _child$attributes$pay
                                  return _c(
                                    "li",
                                    {
                                      key: child.id,
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to:
                                              "/structural_element/" + child.id,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cw-block-table-of-contents-title-box",
                                              class: [
                                                (_child$attributes$pay =
                                                  child.attributes.payload
                                                    .color) !== null &&
                                                _child$attributes$pay !== void 0
                                                  ? _child$attributes$pay
                                                  : "studip-blue",
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    child.attributes.title
                                                  ) +
                                                  "\n                                "
                                              ),
                                              child.attributes.purpose ===
                                              "task"
                                                ? _c("span", [
                                                    _vm._v(
                                                      " | " +
                                                        _vm._s(child.solverName)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentStyle ===
                                              "list-details"
                                                ? _c("p", [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          child.attributes
                                                            .payload.description
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentStyle === "tiles"
                          ? _c(
                              "ul",
                              {
                                staticClass:
                                  "cw-block-table-of-contents-tiles cw-tiles",
                              },
                              _vm._l(
                                _vm.childElementsWithTasks,
                                function (child) {
                                  var _child$attributes$pay2
                                  return _c(
                                    "li",
                                    {
                                      key: child.id,
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to:
                                              "/structural_element/" + child.id,
                                            title:
                                              child.attributes.purpose ===
                                              "task"
                                                ? child.attributes.title +
                                                  " | " +
                                                  child.solverName
                                                : child.attributes.title,
                                          },
                                        },
                                        [
                                          _c("courseware-tile", {
                                            attrs: {
                                              tag: "div",
                                              color:
                                                (_child$attributes$pay2 =
                                                  child.attributes.payload
                                                    .color) !== null &&
                                                _child$attributes$pay2 !==
                                                  void 0
                                                  ? _child$attributes$pay2
                                                  : "studip-blue",
                                              title: child.attributes.title,
                                              imageUrl:
                                                _vm.getChildImageUrl(child),
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                child.attributes.purpose ===
                                                "task"
                                                  ? {
                                                      key: "image-overlay",
                                                      fn: function fn() {
                                                        return [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                child.solverName
                                                              ) +
                                                              "\n                                "
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    }
                                                  : null,
                                                {
                                                  key: "description",
                                                  fn: function fn() {
                                                    return [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            child.attributes
                                                              .payload
                                                              .description
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "footer",
                                                  fn: function fn() {
                                                    return [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$gettextInterpolate(
                                                              _vm.$ngettext(
                                                                "%{length} Seite",
                                                                "%{length} Seiten",
                                                                _vm.countChildChildren(
                                                                  child
                                                                )
                                                              ),
                                                              {
                                                                length:
                                                                  _vm.countChildChildren(
                                                                    child
                                                                  ),
                                                              }
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.viewMode === "edit" &&
                  _vm.childElementsWithTasks.length === 0
                    ? _c("courseware-companion-box", {
                        attrs: {
                          msgCompanion: _vm.$gettext(
                            "Es sind noch keine Unterseiten vorhanden. " +
                              "Sobald Sie weitere Unterseiten anlegen, erscheinen diese automatisch hier im Inhaltsverzeichnis."
                          ),
                          mood: "pointing",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Überschrift")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentTitle,
                                  expression: "currentTitle",
                                },
                              ],
                              attrs: {
                                type: "text",
                              },
                              domProps: {
                                value: _vm.currentTitle,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentTitle = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Layout")) +
                                "\n                    "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentStyle,
                                    expression: "currentStyle",
                                  },
                                ],
                                on: {
                                  change: function change($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.currentStyle = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "list",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Liste")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "list-details",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$gettext("Liste mit Beschreibung")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "tiles",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Kacheln")))]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(
                    _vm._s(
                      _vm.$gettext("Informationen zum Inhaltsverzeichnis-Block")
                    )
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }